/**
 * Google Ads conversion tracking for the TMUA paid-search campaign.
 *
 * The account-level Google tag (gtag.js) is injected in app/layout.tsx, but only
 * on the live tmua.fyi host. This module fires the "Sign up" conversion when a
 * newly created user is first identified (see PosthogIdentify). Every entry point
 * self-guards, so it is inert on esat.fyi, previews, and localhost, and when the
 * conversion label is not configured.
 *
 * No "use client" directive: this is plain constants + guarded helpers, imported
 * by both the server layout (the id) and client components (the fire helper).
 */

// Google Ads account-level tag id. Public value, safe to ship in the bundle.
export const GOOGLE_ADS_ID = "AW-18405992772";

// Conversion label for the Google Ads "Sign up" conversion action, from its
// event snippet (send_to `AW-18405992772/<label>`). Public value, safe in the
// bundle. An env var can override it if the action is ever recreated/rotated.
export const GOOGLE_ADS_SIGNUP_LABEL =
  process.env.NEXT_PUBLIC_GOOGLE_ADS_SIGNUP_LABEL ?? "o5VYCMrEq-YcEMTS1MhE";

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

/** Only the live tmua.fyi apex runs the Google Ads campaign. */
export function isGoogleAdsHost(): boolean {
  return typeof window !== "undefined" && window.location.hostname === "tmua.fyi";
}

/** Fire the Google Ads "Sign up" conversion. Inert unless on tmua.fyi with the
 *  gtag loaded and a conversion label configured. */
export function trackGoogleAdsSignupConversion(): void {
  if (!isGoogleAdsHost()) return;
  if (!GOOGLE_ADS_SIGNUP_LABEL) return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", "conversion", {
      send_to: `${GOOGLE_ADS_ID}/${GOOGLE_ADS_SIGNUP_LABEL}`,
      value: 1.0,
      currency: "GBP",
    });
  } catch (error) {
    if (process.env.NODE_ENV === "development") {
      console.warn("Google Ads conversion failed", error);
    }
  }
}
